import LogoBaseController from "./logo_base_controller.js";

// Connects to data-controller="logo--remove-logo"
export default class extends LogoBaseController {
  removeLogo() {
    this.updateHiddenField("#site_logo_library_file_id", '');
    this.updateHiddenField("#site_logo_preview_url", '');

    const form = document.querySelector('form.header_form');
    if (form) {
      form.requestSubmit();
    }
  }
}
